"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = void 0;
function isNumber(val) {
    return !Number.isNaN(Number(val));
}
exports.isNumber = isNumber;
